import { apiService } from './apiService';

export type VendorSettlement = {
  id: number;
  settlement_number: string;
  settlement_date: string;
  vendor_id: number;
  vendor_name?: string | null;
  vendor_code?: string | null;
  gross_amount: number;
  tds_applicable: boolean;
  tds_rate?: number | null;
  tds_amount: number;
  net_paid: number;
  payment_method: string;
  payment_reference?: string | null;
  withholding_certificate_no?: string | null;
  po_id?: number | null;
  grpo_id?: number | null;
  notes?: string | null;
  pay_to_supplier: number;
  withhold_for_drc: number;
};

export type SettlementCreatePayload = {
  vendor_id: number;
  settlement_date: string;
  gross_amount: number;
  payment_method?: string;
  payment_reference?: string | null;
  withholding_certificate_no?: string | null;
  po_id?: number | null;
  grpo_id?: number | null;
  notes?: string | null;
  apply_tds?: boolean | null;
  tds_rate?: number | null;
};

export type TdsPreview = {
  gross_amount: number;
  tds_applicable: boolean;
  tds_rate?: number | null;
  tds_amount: number;
  net_paid: number;
  pay_to_supplier: number;
  withhold_for_drc: number;
};

export type TdsReport = {
  start_date: string;
  end_date: string;
  total_gross: number;
  total_tds: number;
  total_net_paid: number;
  rows: Array<{
    settlement_id: number;
    settlement_number: string;
    settlement_date: string;
    vendor_id: number;
    vendor_name: string;
    vendor_code: string;
    gross_amount: number;
    tds_rate?: number | null;
    tds_amount: number;
    net_paid: number;
    withholding_certificate_no?: string | null;
  }>;
};

export async function previewVendorSettlement(payload: SettlementCreatePayload): Promise<TdsPreview> {
  return apiService.post<TdsPreview>('/vendor-settlements/settlements/preview', payload);
}

export async function createVendorSettlement(payload: SettlementCreatePayload): Promise<VendorSettlement> {
  return apiService.post<VendorSettlement>('/vendor-settlements/settlements', payload);
}

export async function listVendorSettlements(
  startDate: string,
  endDate: string,
  vendorId?: number,
): Promise<VendorSettlement[]> {
  const params: Record<string, string | number> = {
    start_date: startDate,
    end_date: endDate,
  };
  if (vendorId) params.vendor_id = vendorId;
  return apiService.get<VendorSettlement[]>('/vendor-settlements/settlements', params);
}

export async function getTdsReport(startDate: string, endDate: string): Promise<TdsReport> {
  return apiService.get<TdsReport>('/vendor-settlements/tds-report', {
    start_date: startDate,
    end_date: endDate,
  });
}
